export const BasicColor = "#272703";
export const ContrastColor = "#7c7a05";
export const ClinicColors = { Clinic1: "#004F5B", Clinic2: "red" };

export const VisitTypesConst = ["Consultation", "Revisit", "Others"];

export const isHomevisit = false;

export const currTranslation = {
  AED: "الدرهم الإماراتي",
  AFN: "أفغاني أفغاني",
  ALL: "ليك ألباني",
  AMD: "درام أرميني",
  ANG: "غيلدر الأنتيل الهولندية",
  AOA: "كوانزا أنغولي",
  ARS: "بيزو أرجنتيني",
  AUD: "دولار أسترالي",
  AWG: "فلورن أروبي",
  AZN: "مانات أذربيجاني",
  BAM: "مارك البوسنة والهرسك",
  BBD: "دولار بربادوسي",
  BDT: "تاكا بنغلاديشي",
  BGN: "ليف بلغاري",
  BHD: "دينار البحرين",
  BIF: "فرنك بوروندي",
  BMD: "دولار برمودي",
  BND: "دولار بروناي",
  BOB: "بوليفيانو بوليفي",
  BRL: "ريال برازيلي",
  BSD: "دولار باهامي",
  BTN: "نغولترم بوتاني",
  BWP: "بولا بوتسواني",
  BYN: "روبل بيلاروسي",
  BZD: "دولار بليزي",
  CAD: "دولار كندي",
  CDF: "فرنك كونغولي",
  CHF: "فرنك سويسري",
  CLP: "بيزو تشيلي",
  CNY: "يوان صيني",
  COP: "بيزو كولومبي",
  CRC: "كولون كوستاريكي",
  CUP: "بيزو كوبي",
  CVE: "إسكود كابو فيردي",
  CZK: "كرونة تشيكية",
  DJF: "فرنك جيبوتي",
  DKK: "كرونة دانماركية",
  DOP: "بيزو دومينيكاني",
  DZD: "دينار جزائري",
  EGP: "جنيه مصري",
  ERN: "ناكفا إريتري",
  ETB: "بير إثيوبي",
  EUR: "يورو",
  FJD: "دولار فيجي",
  FKP: "جنيه فوكلاندي",
  FOK: "كرونة فاروسية",
  GBP: "جنيه إسترليني",
  GEL: "لاري جورجي",
  GGP: "جنيه جيرنزي",
  GHS: "سيدي غاني",
  GIP: "جنيه جبرالتار",
  GMD: "دالاسي غامبي",
  GNF: "فرنك غيني",
  GTQ: "كيتزال جواتيمالي",
  GYD: "دولار غياني",
  HKD: "دولار هونغ كونغ",
  HNL: "لمبيرتا هندوراسي",
  HRK: "كرونة كرواتية",
  HTG: "غورد كونا هايتي",
  HUF: "فورنت المجر",
  IDR: "روبية إندونيسية",
  ILS: "شيقل إسرائيلي",
  IMP: "بني أيرلندي",
  INR: "روبية هندية",
  IQD: "دينار عراقي",
  IRR: "ريال إيراني",
  ISK: "كرونة آيسلندية",
  JEP: "جنيه جيرسي",
  JMD: "دولار جامايكي",
  JOD: "دينار أردني",
  JPY: "ين ياباني",
  KES: "شلن كيني",
  KGS: "سوم قيرغيزستاني",
  KHR: "ريال كمبودي",
  KID: "دولار كيريباتي",
  KMF: "فرنك كومورو",
  KRW: "وون كوريا الجنوبية",
  KWD: "دينار كويتي",
  KYD: "دولار جزر كايمان",
  KZT: "تينغ كازاخستاني",
  LAK: "كيبات لاوسي",
  LBP: "ليرة لبنانية",
  LKR: "روبية سريلانكية",
  LRD: "دولار ليبرياني",
  LSL: "لوتي ليسوتو",
  LYD: "دينار ليبي",
  MAD: "درهم مغربي",
  MDL: "ليو مولدوفي",
  MGA: "أرياري مدغشقري",
  MKD: "دينار مقدوني",
  MMK: "كيات ميانمار",
  MNT: "توغروغ منغولي",
  MOP: "باتاكا ماكاوي",
  MRU: "أوقية موريتانية",
  MUR: "روبية موريشيوسية",
  MVR: "روفيه جزر الملديف",
  MWK: "كواشا مالاوي",
  MXN: "بيزو مكسيكي",
  MYR: "رينغيت ماليزي",
  MZN: "متكال موزمبيقي",
  NAD: "دولار ناميبي",
  NGN: "نايرا نيجيري",
  NIO: "كوردوبا نيكاراغوا",
  NOK: "كرونة نرويجية",
  NPR: "روبية نيبالية",
  NZD: "دولار نيوزيلندي",
  OMR: "ريال عماني",
  PAB: "بالبوا بنمي",
  PEN: "سول بيروفي",
  PGK: "كينا بابوا غينيا الجديدة",
  PHP: "بيزو فلبيني",
  PKR: "روبية باكستانية",
  PLN: "زلوتي بولندي",
  PYG: "غواراني باراغواي",
  QAR: "ريال قطري",
  RON: "ليو روماني",
  RSD: "دينار صربي",
  RUB: "روبل روسي",
  RWF: "فرنك رواندي",
  SAR: "ريال سعودي",
  SBD: "دولار جزر سليمان",
  SCR: "روبية سيشيلية",
  SDG: "جنيه سوداني",
  SEK: "كرونة سويدية",
  SGD: "دولار سنغافوري",
  SHP: "جنيه سانت هيلين",
  SLE: "ليون سيراليوني",
  SLL: "ليون سيراليوني",
  SOS: "شلن صومالي",
  SRD: "دولار سورينامي",
  SSP: "جنيه جنوب السودان",
  STN: "دوبرا ساو تومي وبرينسيبي",
  SYP: "ليرة سورية",
  SZL: "ليلانجيني سوازيلندي",
  THB: "باخت تايلاندي",
  TJS: "سوموني طاجيكستاني",
  TMT: "مانات تركمانستاني",
  TND: "دينار تونسي",
  TOP: "بانغا تونغا",
  TRY: "ليرة تركية",
  TTD: "دولار ترينيداد وتوباغو",
  TVD: "دولار توفالو",
  TWD: "دولار تايواني",
  TZS: "شلن تنزاني",
  UAH: "هريفنيا أوكرانية",
  UGX: "شلن أوغندي",
  USD: "دولار أمريكي",
  UYU: "بيزو أوروغواي",
  UZS: "سوم أوزبكي",
  VES: "بوليفار فنزويلي",
  VND: "دونج فيتنامي",
  VUV: "فاتو فانواتو",
  WST: "تالا ساموا",
  XAF: "فرنك وسط أفريقي",
  XCD: "دولار شرق الكاريبي",
  XDR: "حقوق السحب الخاصة",
  XOF: "فرنك غرب أفريقيا",
  XPF: "فرنك سي إف بي",
  YER: "ريال يمني",
  ZAR: "راند جنوب أفريقي",
  ZMW: "كواشا زامبيا",
  ZWL: "دولار زيمبابوي",
};

// npm run build
// true:
// "site": "homevisit",
// "site": "elhallclinics",

//firebase deploy --only hosting:homevisit
// firebase deploy --only hosting:elhallclinics
// false:
//"site": "elhall-clinic-admin",
// firebase deploy --only hosting:elhall-clinic-admin
